import React from 'react'
import { useController } from 'react-hook-form'

export const FileInput = (props) => {
  const { name, id, accept, control, onChange } = props

  const { field } = useController({ name, control })
  const [files, setFiles] = React.useState('')

  function handleChange(e) {
    onChange?.(e)
    setFiles(e.target.value)
    field.onChange(e.target.files)
  }

  return (
    <input
      type="file"
      id={id}
      accept={accept ? accept : undefined}
      value={files}
      onChange={handleChange}
      onBlur={field.onBlur}
      ref={field.ref}
    />
  )
}
